function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_CLAIMS_BEGIN, fetchClaimsSuccess, logError } from "../actions";
import sources from "../utils/JsonSources";
import graphParser from "../utils/JSONGraphParser";
import { getAjaxSettings } from "../utils/getAjaxSettings";
import handleAjaxError from "../utils/handleAjaxError";
export default function fetchClaimsEpic(action$, state$) {
    return action$.pipe(ofType(FETCH_CLAIMS_BEGIN), mergeMap(function(action) {
        return ajax(getAjaxSettings(sources.claimPath, state$.value)).pipe(switchMap(function(param) {
            var response = param.response;
            if (!response) {
                location.href = "/";
                return [];
            }
            var parsed = graphParser.parse(response);
            var keys = Object.keys(parsed);
            var i = 0;
            while(i < keys.length){
                parsed[keys[i]] = parsed[keys[i]].map(function(c) {
                    var type = Object.keys(c)[0];
                    return _objectSpread({
                        type: type
                    }, c[type]);
                });
                i++;
            }
            return [
                fetchClaimsSuccess({
                    claims: parsed
                })
            ];
        }), catchError(function(error) {
            return handleAjaxError(error, "fetch_claims", action);
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_claims"
        }));
    }));
}
